import { FormControl } from '@angular/forms';

export function onlyInteger() {
  return (control: FormControl) => {
    const value = control.value;
    return Number.isInteger(value) ? null : { onlyInteger: false };
  };
}

